// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"23":"class-manager","130":"qunfa","467":"download","634":"empty","695":"other","792":"main","962":"home","966":"login"}[chunkId] + "." + {"23":"73ab8af4","130":"1f343214","467":"a59badca","634":"11b5fbec","695":"35fa9bf8","792":"8e7f0dd7","962":"d99b1229","966":"12263613"}[chunkId] + ".js";
};